import React from 'react'

export default function Heading({ text, subText, className = "" }) {
  return (
    <>
      <h1 className={`text-xl sm:text-4xl md:text-3xl pb-1 sm:pb-2 lg:pb-2 lg:text-5xl text-center text-[#661e33] font-playfair whitespace-nowrap ${className}`}
        fetchpriority="high"
      >
        {text}
        {subText && (
          <span className="text-[#0d5f07] inline-block -mt-1 sm:-mt-2">
            {subText}
          </span>
        )}
      </h1>
    </>
  )
}